<template>
  <video 
    ref="player"
    :controls="controls"
    :src="src"
  ></video>
</template>

<script>
export default {
  name: 'cx-video',
  props: {
    src: {
      type: String,
      default: ''
    },
    controls: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    player: function() {
      return  this.$refs && this.$refs['player'];
    }
  },
  methods: {
    play: function() {
      this.player && this.player.play();
    },
    pause: function() {
      this.player && this.player.pause();
    },
    stop: function() {
      if (this.player) {
        this.player.pause();
        this.player.currentTime = 0;
      }
    }
  }
}
</script>
